/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useEditDatasetCategoryFormStyles = makeStyles(() => ({
  formRoot: {
    paddingTop: '12px',
    width: '650px',
  },
  formControl: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',

    '& .MuiFormHelperText-contained': {
      marginLeft: '0',
    },

    '&:last-child': {
      marginBottom: '0',
    },
  },
  formField: {
    backgroundColor: '#F6F7F8',
    fontSize: '16px',
    lineHeight: '22px',
    color: '#000000',
    border: '1px solid transparent',
    borderRadius: '6px',
    '&:hover': {
      border: '1px solid #A2A7AE',
    },
    '&:focus': {
      border: '1px solid #fff',
    },
    padding: '13px 16px',
    height: 'auto',
  },
  buttonApply: {
    margin: '16px 0',
  },
  title: {
    margin: '0 0 30px 0',
  },
  thumbnailRoot: {
    display: 'flex',
    alignItems: 'center',
  },
  thumbnailWrap: {
    marginRight: '20px',
  },
  thumbnail: {
    borderRadius: '50%',
    '& img': {
      cursor: 'default !important',
    },
  },
  uploadThumbnail: {
    padding: '5px',
    minWidth: '135px',
    maxWidth: '135px',
    '& *': {
      cursor: 'pointer',
    },
  },
  fileChooser: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1,
  },
  pl16: {
    paddingLeft: '16px',
  },
}));
